<div [hidden]="!active" class="autocomplete-overlay">
  <div class="autocomplete-overlay__container">
    <form class="autocomplete-overlay__form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <fieldset #wrapper formGroupName="wrapper" class="autocomplete-overlay__fieldset">
        <div class="autocomplete-overlay__search-main">
          <div class="autocomplete-overlay__field-wrapper">
            <mat-icon *ngIf="searchState === State.Empty || searchState === State.Content"
                      class="autocomplete-overlay__field-icon">search</mat-icon>
            <mat-spinner *ngIf="searchState === State.Loading" [diameter]="16" class="autocomplete-overlay__field-spinner"></mat-spinner>
            <mat-icon *ngIf="searchState === State.Error" class="autocomplete-overlay__field-icon autocomplete-overlay__field-icon--error">warning</mat-icon>
            <input #queryField id="query" type="search" [(ngModel)]="query" (blur)="onQueryBlur()"
                   formControlName="query" class="autocomplete-overlay__field autocomplete-overlay__query-field"
                   aria-label="Search" placeholder="Search" autocomplete="off" autocorrect="off">
          </div>
          <button type="button" (click)="hide()" mat-icon-button class="autocomplete-overlay__close">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </fieldset>
    </form>
    <div class="autocomplete-overlay__body">
      <app-state-view [state]="state">
        <empty-state></empty-state>
        <loading-state>
          <div class="autocomplete-overlay__loading">
            <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
          </div>
        </loading-state>
        <content-state>
          <div class="autocomplete-overlay__results">
            <div *ngIf="showAirports" class="autocomplete-overlay__category">
              <ng-container *ngVar="airportResults$ | async as airportResults">
                <ng-container *ngIf="airportResults && airportResults.length">
                  <h2 class="autocomplete-overlay__category-header">Airports:</h2>
                  <ul class="autocomplete-overlay__category-results">
                    <li *ngFor="let airport of airportResults" (click)="onSelectAirport(airport)"
                        class="autocomplete-overlay__result">
                      <span class="autocomplete__airport" [innerHTML]="getAirportText(airport) | highlight: query"></span>
                      <span class="autocomplete__city-state" [innerHTML]="getCityStateText(airport) | highlight: query"></span>
                    </li>
                    <li *ngIf="sanitizedQuery.length >= 3 && currentSearchTab != searchFormType.FuelPrice" (click)="onSubmit()" class="autocomplete-overlay__result">
                      Search for Airport/City names containing "{{ sanitizedQuery }}"
                    </li>
                  </ul>
                </ng-container>
              </ng-container>
            </div>
            <div *ngIf="showGoogle" class="autocomplete-overlay__category">
              <ng-container *ngVar="googleResults$ | async as googleResults">
                <ng-container *ngIf="googleResults && googleResults.length">
                  <h2 class="autocomplete-overlay__category-header">Locations:</h2>
                  <ul class="autocomplete-overlay__category-results">
                    <li *ngFor="let location of googleResults" (click)="onSelectLocation(location)"
                        class="autocomplete-overlay__result">
                      <span class="autocomplete__airport" [innerHTML]="location.description | highlight: query"></span>
                      <span class="autocomplete__city-state" [innerHTML]="getCityText()"></span>
                    </li>
                  </ul>
                </ng-container>
              </ng-container>
              <ng-container *ngVar="usStateResults$ | async as usStateResults">
                <ng-container *ngIf="usStateResults && usStateResults.length">
                  <ul class="autocomplete-overlay__category-results">
                    <li *ngFor="let state of usStateResults" (click)="onSelectUSState(state)"
                        class="autocomplete-overlay__result">
                      <span class="autocomplete__airport" [innerHTML]="state.name | highlight: query"></span>
                      <span class="autocomplete__city-state" [innerHTML]="getStateTerritoryText()"></span>
                    </li>
                  </ul>
                </ng-container>
              </ng-container>
            </div>
            <div *ngIf="showInternational" class="autocomplete-overlay__category">
              <ng-container *ngVar="internationalCityResults$ | async as internationalResults">
                <ng-container *ngIf="internationalResults && internationalResults.length">
                  <h2 class="autocomplete-overlay__category-header">Locations:</h2>
                  <ul class="autocomplete-overlay__category-results">
                    <li *ngFor="let location of internationalResults" (click)="onSelectLocation(location)"
                        class="autocomplete-overlay__result">
                      <span class="autocomplete__airport" [innerHTML]="location.description | highlight: query"></span>
                      <span class="autocomplete__city-state" [innerHTML]="getInternationalText(location)"></span>
                    </li>
                  </ul>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </content-state>
        <error-state>
          <div class="autocomplete-overlay__placeholder autocomplete-overlay__placeholder--error">
            <mat-icon class="autocomplete-overlay__placeholder-icon">warning</mat-icon>
            <div class="autocomplete-overlay__placeholder-message">
              An error occurred performing the search. Please try again later.
            </div>
          </div>
        </error-state>
      </app-state-view>
    </div>
  </div>
</div>
